(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    /* Sugar Creek: progress bar for the hamburger image slider */
  if (!customElements.get('sc-drawer-slider')) {
    customElements.define(
      'sc-drawer-slider',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-sc-track]');
          this.thumb = this.querySelector('[data-sc-thumb]');
          if (!this.track || !this.thumb) return;
          const update = () => {
            const { scrollWidth, clientWidth, scrollLeft } = this.track;
            const visible = scrollWidth > 0 ? Math.min(1, clientWidth / scrollWidth) : 1;
            const max = Math.max(1, scrollWidth - clientWidth);
            this.thumb.style.setProperty('--sc-thumb', `${visible * 100}%`);
            this.thumb.style.setProperty('--sc-pos', `${(scrollLeft / max) * ((1 - visible) / visible) * 100}%`);
            this.thumb.parentElement.hidden = visible >= 1;
          };
          let raf = null;
          this.track.addEventListener('scroll', () => {
            if (raf) return;
            raf = requestAnimationFrame(() => {
              raf = null;
              update();
            });
          }, { passive: true });
          new ResizeObserver(update).observe(this.track);
          update();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["list-filter"] && !Shopify.designMode) return;
  try {
    // Sugar Creek: "N selected / Reset" row in the Elwood-style filter drawer
  (() => {
    if (window.__scFacetMeta) return;
    window.__scFacetMeta = true;
    const sync = (root) => {
      const n = root.querySelectorAll('input[type="checkbox"]:checked').length;
      const out = root.querySelector('[data-sc-facet-count]');
      if (out) out.textContent = String(n);
    };
    document.addEventListener('change', (event) => {
      const root = event.target.closest?.('facet-inputs-component');
      if (root?.querySelector('[data-sc-facet-count]')) sync(root);
    });
    // Desktop filter panel shows the same Sort dropdown as mobile. On desktop Horizon reads the
    // sort radio buttons (not the dropdown), so mirror the dropdown's choice onto them first.
    const syncSort = (event) => {
      const select = event.target.closest?.('.sc-elwood-drawer sorting-filter-component select[name="sort_by"]');
      if (!select || window.innerWidth < 750) return;
      document
        .querySelectorAll(`input[name="sort_by"][value="${CSS.escape(select.value)}"]`)
        .forEach((radio) => (radio.checked = true));
    };
    document.addEventListener('input', syncSort, true);
    document.addEventListener('change', syncSort, true);
    document.addEventListener('click', (event) => {
      const button = event.target.closest?.('[data-sc-facet-reset]');
      if (!button) return;
      event.preventDefault();
      const root = button.closest('facet-inputs-component');
      if (!root) return;
      const checked = [...root.querySelectorAll('input[type="checkbox"]:checked')];
      if (!checked.length) return;
      checked.forEach((input) => (input.checked = false));
      checked[checked.length - 1].dispatchEvent(new Event('change', { bubbles: true }));
      sync(root);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sc-card-media"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__scCardMedia) return;
    window.__scCardMedia = true;

    const idle = (fn) => ('requestIdleCallback' in window ? requestIdleCallback(fn, { timeout: 1200 }) : setTimeout(fn, 200));
    const hasIO = 'IntersectionObserver' in window;

    /* ---------- cut-out vs photo, read from the image that is already loaded ---------- */
    const kinds = new Map();
    let canvas;
    const classify = (img) => {
      const key = (img.currentSrc || img.src || '').split('?')[0];
      if (!key) return 'photo';
      if (kinds.has(key)) return kinds.get(key);
      let kind = 'photo';
      try {
        canvas ??= document.createElement('canvas');
        canvas.width = 24;
        canvas.height = 24;
        const ctx = canvas.getContext('2d', { willReadFrequently: true });
        ctx.clearRect(0, 0, 24, 24);
        ctx.drawImage(img, 0, 0, 24, 24);
        const d = ctx.getImageData(0, 0, 24, 24).data;
        const a = (x, y) => d[(y * 24 + x) * 4 + 3];
        const pts = [a(0, 0), a(23, 0), a(0, 23), a(23, 23), a(0, 12), a(23, 12)];
        if (pts.filter((v) => v < 24).length >= 3) kind = 'cutout';
      } catch (e) {
        // The image can't be read (e.g. shown on another domain such as the theme editor):
        // don't guess "photo" (that crops cut-outs) — callers treat this as unknown
        kind = 'unknown';
      }
      if (kind !== 'unknown') kinds.set(key, kind);
      return kind;
    };
    // Share of the image the product itself takes up (non-transparent area), for cut-outs
    const boxes = new Map();
    const productBox = (img) => {
      const key = (img.currentSrc || img.src || '').split('?')[0];
      if (boxes.has(key)) return boxes.get(key);
      let box = null;
      try {
        const N = 64;
        canvas ??= document.createElement('canvas');
        canvas.width = N;
        canvas.height = N;
        const ctx = canvas.getContext('2d', { willReadFrequently: true });
        ctx.clearRect(0, 0, N, N);
        ctx.drawImage(img, 0, 0, N, N);
        const d = ctx.getImageData(0, 0, N, N).data;
        let x0 = N, y0 = N, x1 = -1, y1 = -1;
        for (let y = 0; y < N; y++) {
          for (let x = 0; x < N; x++) {
            if (d[(y * N + x) * 4 + 3] > 24) {
              if (x < x0) x0 = x;
              if (x > x1) x1 = x;
              if (y < y0) y0 = y;
              if (y > y1) y1 = y;
            }
          }
        }
        if (x1 >= x0 && y1 >= y0) box = { w: (x1 - x0 + 1) / N, h: (y1 - y0 + 1) / N };
      } catch (e) {
        box = null;
      }
      boxes.set(key, box);
      return box;
    };
    // Size the hover cut-out so the product looks the same size as on the main photo
    const matchScale = (img, main, slide) => {
      if (!main || !main.naturalWidth || classify(main) !== 'cutout') return 1;
      const a = productBox(main);
      const b = productBox(img);
      const W = slide.clientWidth;
      const H = slide.clientHeight;
      if (!a || !b || !W || !H) return 1;
      const fit = (el) => Math.min(W / el.naturalWidth, H / el.naturalHeight);
      const mainH = main.naturalHeight * fit(main) * a.h;
      const mainW = main.naturalWidth * fit(main) * a.w;
      const imgH = img.naturalHeight * fit(img) * b.h;
      const imgW = img.naturalWidth * fit(img) * b.w;
      // match the larger dimension of the main product, never wider than the box
      let k = Math.max(mainH / imgH, 0) || 1;
      if (imgW * k > mainW * 1.15 && mainW / imgW > 0) k = Math.min(k, (mainW * 1.15) / imgW);
      k = Math.min(Math.max(k, 0.5), 1.5);
      return Math.abs(k - 1) < 0.03 ? 1 : k;
    };
    const whenLoaded = (img, fn) => {
      if (img.complete && img.naturalWidth) fn();
      else img.addEventListener('load', fn, { once: true });
    };

    const fitCardImage = (img) => {
      if (img.dataset.scFit) return;
      img.dataset.scFit = 'pending';
      whenLoaded(img, () =>
        idle(() => {
          const fit = classify(img) === 'photo' ? 'cover' : 'contain';
          img.dataset.scFit = fit;
          img.closest('slideshow-slide')?.style.setProperty('--product-media-fit', fit, 'important');
          img.style.objectFit = fit;
        })
      );
    };
    const fitGalleryImage = (img) => {
      if (img.dataset.scFit) return;
      img.dataset.scFit = 'pending';
      // Chosen per product (custom.photos_fill / custom.photos_fit)?
      const forced = img.closest('slideshow-slide, li')?.querySelector('[data-sc-force-fit]');
      if (forced) return applyGalleryFit(img, forced.dataset.scForceFit);
      whenLoaded(img, () =>
        (() => {
          const kind = classify(img);
          if (kind === 'unknown') {
            // Can't read this copy (e.g. Shopify admin preview on another domain): check a
            // small CORS copy of the same photo instead
            if (img.dataset.scProbe) return;
            img.dataset.scProbe = '1';
            const probe = new Image();
            probe.crossOrigin = 'anonymous';
            probe.onload = () => {
              const k = classify(probe);
              if (k === 'unknown') return;
              applyGalleryFit(img, k === 'cutout' ? 'contain' : 'cover');
            };
            try {
              const u = new URL(img.currentSrc || img.src, location.href);
              u.searchParams.set('width', '64');
              probe.src = u.href;
            } catch (e) {}
            return;
          }
          applyGalleryFit(img, kind === 'cutout' ? 'contain' : 'cover');
        })()
      );
    };
    const applyGalleryFit = (img, fit) => {
      img.dataset.scFit = fit;
      img.style.setProperty('object-fit', fit, 'important');
      img.style.setProperty('width', '100%', 'important');
      img.style.setProperty('height', '100%', 'important');
      // Photos fill the whole slide on white (no grey bars); "Model is …" pill shows on photos only
      const slide = img.closest('slideshow-slide, li, .product-media-container');
      slide?.classList.toggle('sc-photo', fit === 'cover');
      if (fit === 'cover') slide?.querySelector('.sc-model-badge[data-auto]')?.classList.add('is-shown');
    };

    /* ---------- cards: warm the next photo + fit, only near the viewport ---------- */
    const prepCard = (card) => {
      if (card.querySelector('sc-card-media')) return;
      const imgs = card.querySelectorAll('.card-gallery slideshow-slide img');
      if (imgs[1] && imgs[1].loading === 'lazy') imgs[1].loading = 'eager';
      if (card.closest('[data-sc-hover-fit="auto"]')) {
        card.querySelectorAll('.card-gallery slideshow-slide:not(:first-child) img').forEach((img) => {
          if (img.loading === 'eager' || img.complete) fitCardImage(img);
          else img.addEventListener('load', () => fitCardImage(img), { once: true });
        });
      }
    };
    const cardIO = hasIO
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              cardIO.unobserve(entry.target);
              idle(() => prepCard(entry.target));
            });
          },
          { rootMargin: '400px 0px' }
        )
      : null;

    /* ---------- card videos: play only while visible ---------- */
    const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
    const videoIO = hasIO
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach(({ target: video, isIntersecting }) => {
              if (isIntersecting && !reduceMotion.matches) {
                if (video.preload !== 'auto') video.preload = 'auto';
                video.play?.().catch(() => {});
              } else {
                video.pause?.();
              }
            });
          },
          { threshold: 0.2 }
        )
      : null;

    /* ---------- lightweight card images (sc-card-lean) ---------- */
    const finePointer = matchMedia('(hover: hover) and (pointer: fine)');
    const WIDTHS = [320, 480, 640, 800, 1000];
    const warmIO = hasIO
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              warmIO.unobserve(entry.target);
              idle(() => entry.target.fill?.(1, true));
            });
          },
          { rootMargin: '300px 0px' }
        )
      : null;

    if (!customElements.get('sc-card-media')) {
      class ScCardMedia extends HTMLElement {
        connectedCallback() {
          if (this._wired) return;
          this._wired = true;
          this.index = 0;
          this.addEventListener('pointerenter', (e) => {
            if (e.pointerType === 'mouse' && this.count > 1) this.go(1);
          });
          this.addEventListener('pointerleave', (e) => {
            if (e.pointerType === 'mouse') this.go(0);
          });
          this.addEventListener('click', (e) => {
            const step = e.target.closest('[data-sc-step]');
            if (!step) return;
            e.preventDefault();
            e.stopPropagation();
            this.go(this.index + Number(step.dataset.scStep));
          });
          // Phones: photos 2+ are only added once someone touches this card
          this.addEventListener('touchstart', () => this.wake(), { passive: true, once: true });
          this.addEventListener('scroll', () => this.onScroll(), { capture: true, passive: true });
          // Mouse: get the hover photo ready shortly before the card scrolls into view
          if (finePointer.matches && warmIO) warmIO.observe(this);
        }

        get track() {
          return this.querySelector('[data-sc-track]');
        }

        get count() {
          return this.track ? this.track.children.length : 0;
        }

        /** Adds the <img> for slide i (if it hasn't been added yet). */
        fill(i, eager) {
          const slide = this.track?.children[i];
          if (!slide || !slide.dataset.src || slide.firstElementChild) return;
          const url = (w) => {
            const u = new URL(slide.dataset.src, location.href);
            u.searchParams.set('width', String(w));
            return u.href;
          };
          const img = document.createElement('img');
          img.className = 'sc-cm__img';
          img.alt = '';
          img.decoding = 'async';
          img.crossOrigin = 'anonymous'; // lets the cut-out check read the pixels on any domain
          img.loading = eager ? 'eager' : 'lazy';
          img.sizes = this.querySelector('.sc-cm__img--main')?.getAttribute('sizes') || '50vw';
          img.srcset = WIDTHS.map((w) => `${url(w)} ${w}w`).join(', ');
          img.src = url(640);
          if (this.closest('[data-sc-hover-fit="auto"]')) {
            // Decide cut-out vs photo as soon as it loads, before it can be seen
            img.dataset.scFit = 'pending';
            const show = () => {
              const fit = classify(img) === 'photo' ? 'cover' : 'contain';
              img.style.objectFit = fit;
              if (fit === 'contain') {
                const main = this.querySelector('.sc-cm__img--main');
                const scale = () => {
                  const k = matchScale(img, main, slide);
                  img.style.transform = k !== 1 ? `scale(${k.toFixed(3)})` : '';
                };
                if (main && !(main.complete && main.naturalWidth)) main.addEventListener('load', scale, { once: true });
                else scale();
              }
              img.dataset.scFit = fit;
            };
            img.addEventListener('load', show, { once: true });
            img.addEventListener(
              'error',
              () => {
                // No CORS on this host: load it the normal way and fit it whole (never cropped)
                if (img.crossOrigin) {
                  img.removeAttribute('crossorigin');
                  img.srcset = img.srcset;
                  img.src = img.src;
                }
              },
              { once: true }
            );
          }
          slide.append(img);
        }

        wake() {
          if (this._awake) return;
          this._awake = true;
          this.classList.add('is-swiping');
          for (let i = 1; i < this.count; i++) this.fill(i, i === this.index + 1);
        }

        go(i) {
          const track = this.track;
          if (!track || !this.count) return;
          const n = this.count;
          const next = ((i % n) + n) % n;
          this.fill(next, true);
          this.fill(next + 1, false);
          const slides = track.children;
          if (finePointer.matches) {
            // Stacked photos: just switch which one is visible
            for (let k = 0; k < slides.length; k++) slides[k].classList.toggle('is-active', k === next);
          } else {
            track.scrollTo({ left: slides[next].offsetLeft, behavior: 'instant' });
          }
          this.setIndex(next);
        }

        setIndex(i) {
          if (i === this.index) return;
          this.index = i;
          this.querySelectorAll('.sc-cm__dots i').forEach((dot, k) => dot.classList.toggle('is-on', k === i));
        }

        onScroll() {
          if (this._raf) return;
          this._raf = requestAnimationFrame(() => {
            this._raf = 0;
            const track = this.track;
            if (!track || !track.clientWidth) return;
            if (!finePointer.matches) this.wake();
            const i = Math.round(track.scrollLeft / track.clientWidth);
            this.setIndex(i);
            this.fill(i + 1, true);
          });
        }
      }
      customElements.define('sc-card-media', ScCardMedia);
    }

    /* ---------- product page 2-up gallery: arrows move one photo at a time ---------- */
    const wide = matchMedia('(min-width: 990px)');
    const stepOne = (comp) => {
      if (comp.dataset.scStep) return;
      comp.dataset.scStep = '1';
      customElements.whenDefined('slideshow-component').then(() => {
        const proto = customElements.get('slideshow-component').prototype;
        const base = (name) => Object.getOwnPropertyDescriptor(proto, name)?.get;
        Object.defineProperty(comp, 'nextIndex', {
          configurable: true,
          get() {
            if (!wide.matches) return base('nextIndex').call(this);
            return Math.min(this.current + 1, Math.max((this.slides?.length || 2) - 2, 0));
          },
        });
        Object.defineProperty(comp, 'previousIndex', {
          configurable: true,
          get() {
            if (!wide.matches) return base('previousIndex').call(this);
            return Math.max(this.current - 1, 0);
          },
        });
      });
    };

    /* ---------- product page arrows: solid black or white, whichever stands out ---------- */
    let toneCanvas;
    const lumOf = (rgb) => {
      const m = (rgb || '').match(/[\d.]+/g);
      if (!m) return 1;
      const [r, g, b, a = 1] = m.map(Number);
      if (a < 0.1) return 1;
      return (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
    };
    const bgOf = (el) => {
      for (let n = el; n && n !== document.documentElement; n = n.parentElement) {
        const c = getComputedStyle(n).backgroundColor;
        const m = c.match(/[\d.]+/g);
        if (m && (m[3] === undefined || Number(m[3]) > 0.1)) return c;
      }
      return 'rgb(255, 255, 255)';
    };
    // Brightness of the photo (as shown, incl. cover/contain) in a box around a screen point
    const toneAt = (img, x, y) => {
      const r = img.getBoundingClientRect();
      const bg = bgOf(img);
      const nw = img.naturalWidth;
      const nh = img.naturalHeight;
      if (!nw || !r.width) return lumOf(bg);
      const fit = getComputedStyle(img).objectFit;
      const k = fit === 'cover' ? Math.max(r.width / nw, r.height / nh) : fit === 'contain' ? Math.min(r.width / nw, r.height / nh) : null;
      const dw = k ? nw * k : r.width;
      const dh = k ? nh * k : r.height;
      const left = r.left + (r.width - dw) / 2;
      const top = r.top + (r.height - dh) / 2;
      const S = 10;
      const box = 56;
      const c = S / box;
      toneCanvas ??= document.createElement('canvas');
      toneCanvas.width = S;
      toneCanvas.height = S;
      const ctx = toneCanvas.getContext('2d', { willReadFrequently: true });
      ctx.fillStyle = bg;
      ctx.fillRect(0, 0, S, S);
      ctx.drawImage(img, (left - (x - box / 2)) * c, (top - (y - box / 2)) * c, dw * c, dh * c);
      const d = ctx.getImageData(0, 0, S, S).data; // throws if the photo can't be read
      let sum = 0;
      for (let i = 0; i < d.length; i += 4) sum += (0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2]) / 255;
      return sum / (d.length / 4);
    };
    const toneArrows = (gallery) => {
      gallery.querySelectorAll('slideshow-arrows .slideshow-control').forEach((btn) => {
        const r = btn.getBoundingClientRect();
        if (!r.width) return;
        const x = r.left + r.width / 2;
        const y = r.top + r.height / 2;
        const under = document.elementsFromPoint(x, y).find((el) => el.closest?.('slideshow-slide') && gallery.contains(el));
        const slide = under?.closest('slideshow-slide');
        if (!slide) return;
        const img = slide.querySelector('.product-media img, img');
        let lum;
        try {
          lum = img && img.complete ? toneAt(img, x, y) : lumOf(bgOf(slide));
        } catch (e) {
          return; // photo can't be read here: keep the default
        }
        btn.dataset.scTone = lum < 0.55 ? 'light' : 'dark';
      });
    };
    const watchArrows = (gallery) => {
      if (gallery.dataset.scTone) return;
      gallery.dataset.scTone = '1';
      let t;
      const later = (ms = 140) => {
        clearTimeout(t);
        t = setTimeout(() => toneArrows(gallery), ms);
      };
      gallery.addEventListener('scroll', () => later(), { capture: true, passive: true });
      gallery.addEventListener('load', () => later(60), true);
      gallery.addEventListener('pointerenter', () => later(0));
      addEventListener('resize', () => later(200), { passive: true });
      later(300);
    };

    const scan = (root = document) => {
      root.querySelectorAll?.('product-card:not([data-sc-prep])').forEach((card) => {
        card.setAttribute('data-sc-prep', '');
        cardIO ? cardIO.observe(card) : prepCard(card);
      });
      root.querySelectorAll?.('video[data-sc-card-video]:not([data-sc-prep])').forEach((video) => {
        video.setAttribute('data-sc-prep', '');
        video.muted = true;
        if (videoIO) videoIO.observe(video);
      });
      root
        .querySelectorAll?.(
          "media-gallery[style*='--sc-media-bg'] slideshow-slide .product-media img, media-gallery[style*='--sc-media-bg'] .media-gallery__grid .product-media img"
        )
        .forEach(fitGalleryImage);
      root
        .querySelectorAll?.("media-gallery[data-sc-two-up='true'] slideshow-component")
        .forEach(stepOne);
      root.querySelectorAll?.('media-gallery:has(slideshow-arrows.sc-gallery-arrows)').forEach(watchArrows);
      // Galleries without the SC background still need the auto model pill decided
      root.querySelectorAll?.('.sc-model-badge[data-auto]:not([data-sc-prep])').forEach((badge) => {
        badge.setAttribute('data-sc-prep', '');
        const img = badge.parentElement?.querySelector('img');
        if (!img || img.dataset.scFit) return;
        whenLoaded(img, () => idle(() => classify(img) === 'photo' && badge.classList.add('is-shown')));
      });
    };

    const start = () => scan();
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
    document.addEventListener('shopify:section:load', (e) => scan(e.target || document));

    // New cards (infinite scroll, filters, recommendations): only react to added elements
    let queued = false;
    new MutationObserver((mutations) => {
      if (queued) return;
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (node.nodeType === 1 && (node.matches('product-card, media-gallery, video') || node.querySelector('product-card, media-gallery, video[data-sc-card-video]'))) {
            queued = true;
            idle(() => {
              queued = false;
              scan();
            });
            return;
          }
        }
      }
    }).observe(document.body || document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sc-cart-recommendations"] && !Shopify.designMode) return;
  try {
    (() => {
    // Cache related products per first-cart-item so the cart doesn't flicker on every update
    const cache = (window.__scRecsCache = window.__scRecsCache || new Map());

    if (!customElements.get('sc-cart-recs')) {
      class ScCartRecs extends HTMLElement {
        static get observedAttributes() {
          return ['data-url', 'data-cart-ids'];
        }

        connectedCallback() {
          this.track = this.querySelector('[data-sc-recs-track]');
          if (!this.track) return;
          // Keep the server-rendered cards as a backup list
          if (!this.fallback) this.fallback = [...this.track.querySelectorAll('.sc-rec')].map((el) => el.outerHTML);
          this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
          this.addEventListener('click', this.onClick);
          this.refresh();
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.onClick);
        }

        attributeChangedCallback(name, oldValue, newValue) {
          if (oldValue === newValue || !this.track) return;
          this.refresh();
        }

        onClick = (event) => {
          if (event.target.closest('[data-sc-recs-prev]')) this.scroll(-1);
          if (event.target.closest('[data-sc-recs-next]')) this.scroll(1);
        };

        scroll(direction) {
          const card = this.track.querySelector('.sc-rec');
          const amount = card ? card.getBoundingClientRect().width + 4 : this.track.clientWidth;
          this.track.scrollBy({ left: amount * direction, behavior: 'smooth' });
        }

        updateArrows() {
          const max = this.track.scrollWidth - this.track.clientWidth;
          const prev = this.querySelector('[data-sc-recs-prev]');
          const next = this.querySelector('[data-sc-recs-next]');
          if (prev) prev.disabled = this.track.scrollLeft <= 2;
          if (next) next.disabled = this.track.scrollLeft >= max - 2;
        }

        async related() {
          const url = this.dataset.url;
          if (!url) return [];
          if (cache.has(url)) return cache.get(url);
          try {
            const response = await fetch(url);
            if (!response.ok) return [];
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const cards = [...doc.querySelectorAll('[data-sc-recs-track] .sc-rec')].map((el) => el.outerHTML);
            cache.set(url, cards);
            return cards;
          } catch (e) {
            return [];
          }
        }

        async refresh() {
          const token = (this._token = (this._token || 0) + 1);
          const inCart = new Set((this.dataset.cartIds || '').split(',').filter(Boolean));
          const limit = Number(this.dataset.limit) || 8;
          const related = await this.related();
          if (token !== this._token || !this.isConnected) return;

          // Related products first, topped up from the backup list; skip anything already in the cart
          const seen = new Set();
          const cards = [];
          for (const html of [...related, ...(this.fallback || [])]) {
            const id = (html.match(/data-product-id="(\d+)"/) || [])[1];
            if (!id || inCart.has(id) || seen.has(id)) continue;
            seen.add(id);
            cards.push(html);
            if (cards.length >= limit) break;
          }

          const next = cards.join('');
          if (this._rendered !== next) {
            this._rendered = next;
            this.track.innerHTML = next;
            this.track.scrollLeft = 0;
          }
          this.hidden = cards.length === 0;
          this.updateArrows();
        }
      }
      customElements.define('sc-cart-recs', ScCartRecs);
    }

    if (window.__scRecBound) return;
    window.__scRecBound = true;

    // Size buttons
    document.addEventListener('click', (event) => {
      const size = event.target.closest('[data-sc-rec-variant]');
      if (!size || size.disabled) return;
      const card = size.closest('[data-sc-rec]');
      if (!card) return;
      card.querySelectorAll('[data-sc-rec-variant]').forEach((b) => b.setAttribute('aria-pressed', String(b === size)));
      const input = card.querySelector('input[name="id"]');
      if (input) input.value = size.dataset.scRecVariant;
      const add = card.querySelector('.sc-rec__add');
      if (add) add.disabled = false;
    });

    // No "fly to cart" animation for these buttons (runs before the theme's click handler)
    document.addEventListener(
      'click',
      (event) => {
        const add = event.target.closest('.sc-rec__add, .sc-qv__atc, .sc-ctl__add');
        const container = add?.closest('add-to-cart-component');
        if (container) container.dataset.addToCartAnimation = 'false';
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sc-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sc-countdown')) {
    const pad = (n) => String(n).padStart(2, '0');
    const all = new Set();
    let timer;
    const tick = () => {
      const now = Date.now();
      all.forEach((el) => (el.isConnected ? el.render(now) : all.delete(el)));
      if (!all.size) {
        clearInterval(timer);
        timer = null;
      }
    };
    const loadedAt = Date.now();

    class ScCountdown extends HTMLElement {
      connectedCallback() {
        this.end = Number(this.dataset.end) * 1000;
        if (!this.end) return;
        const date = this.querySelector('[data-sc-cd-date]');
        if (date) {
          try {
            date.textContent = new Intl.DateTimeFormat(undefined, {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              hour: 'numeric',
              minute: '2-digit',
              timeZoneName: 'short',
            }).format(new Date(this.end));
          } catch (e) {}
        }
        this.render(Date.now());
        all.add(this);
        timer ??= setInterval(tick, 1000);
      }

      render(now) {
        let left = Math.max(0, Math.floor((this.end - now) / 1000));
        const d = Math.floor(left / 86400);
        const h = Math.floor((left % 86400) / 3600);
        const m = Math.floor((left % 3600) / 60);
        const s = left % 60;
        const compact = this.querySelector('[data-sc-cd-compact]');
        if (compact) {
          compact.textContent = d > 0 ? `${d}d ${h}h ${pad(m)}m` : `${h}h ${pad(m)}m ${pad(s)}s`;
        } else {
          const set = (k, v) => {
            const el = this.querySelector(`[data-sc-cd="${k}"]`);
            if (el && el.textContent !== v) el.textContent = v;
          };
          set('d', pad(d));
          set('h', pad(h));
          set('m', pad(m));
          set('s', pad(s));
        }
        if (left === 0) {
          all.delete(this);
          // Drop time reached: reload once so the product shows as available
          // (only if the page was opened before the drop, so it can't loop)
          if (this.dataset.style !== 'compact' && loadedAt < this.end && !this._reloading) {
            this._reloading = true;
            setTimeout(() => location.reload(), 1500);
          }
        }
      }
    }
    customElements.define('sc-countdown', ScCountdown);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sc-newsletter-popup"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sc-newsletter-popup')) {
    const KEY = 'sc_nl_v1';
    const read = () => {
      try {
        return JSON.parse(localStorage.getItem(KEY) || '{}');
      } catch (e) {
        return {};
      }
    };
    const write = (data) => {
      try {
        localStorage.setItem(KEY, JSON.stringify({ ...read(), ...data }));
      } catch (e) {}
    };

    // Slot machine symbols (theme assets sc-slot-*.png); the red 7 is the jackpot
    const SYMBOLS = ['seven', 'horseshoe', 'bar', 'cherry', 'clover', 'grapes', 'diamond', 'dollar', 'apple'];
    const FILLERS = SYMBOLS.slice(1);
    const JACKPOT = 'seven';
    const reduce = matchMedia('(prefers-reduced-motion: reduce)');

    class ScNewsletterPopup extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this.dialog = this.querySelector('dialog');
        this.form = this.querySelector('form');
        this.teaser = this.querySelector('[data-sc-nl-teaser]');
        if (!this.dialog || !this.form) return;

        this.addEventListener('click', (event) => {
          if (event.target.closest('[data-sc-nl-teaser-close]')) {
            event.stopPropagation();
            this.teaser.hidden = true;
            write({ teaserClosed: Date.now() });
            return;
          }
          if (event.target.closest('[data-sc-nl-teaser]')) return this.open();
          if (event.target.closest('[data-sc-nl-close]') || event.target === this.dialog) this.close();
          const copy = event.target.closest('[data-sc-nl-copy]');
          if (copy) {
            navigator.clipboard?.writeText(copy.dataset.code).then(() => {
              const label = copy.querySelector('[data-sc-nl-copied]');
              if (label) label.textContent = 'Copied';
            });
          }
        });
        this.dialog.addEventListener('close', () => {
          if (!this.dialog.hasAttribute('data-success')) {
            write({ dismissed: Date.now() });
            if (this.teaser && !read().teaserClosed) this.teaser.hidden = false;
          }
        });
        this.form.addEventListener('submit', (event) => this.submit(event));
        this.setupSlots();

        const state = read();
        // Came back from a normal (non-JS) form post
        // Signed up through a product's "Get notified" popup instead: that one shows the thanks
        if (document.querySelector('.sc-notify__dialog[data-success]')) {
          write({ subscribed: Date.now() });
          return;
        }
        if (this.dialog.hasAttribute('data-success') || /customer_posted=true/.test(location.search)) {
          this.dialog.setAttribute('data-success', '');
          write({ subscribed: Date.now() });
          return this.open();
        }
        if (this.hasAttribute('data-preview')) return this.open();
        if (state.subscribed) return;
        const days = Number(this.dataset.days || 30);
        if (state.dismissed && Date.now() - state.dismissed < days * 864e5) {
          if (this.teaser && !state.teaserClosed) this.teaser.hidden = false;
          return;
        }
        setTimeout(() => {
          if (!document.querySelector('dialog[open]:modal')) this.open();
        }, Number(this.dataset.delay || 3) * 1000);
      }

      /* ---------- slot machine ---------- */
      setupSlots() {
        this.game = this.querySelector('.sc-slots');
        if (!this.game) return;
        this.strips = [...this.game.querySelectorAll('[data-sc-strip]')];
        this.warm();
        if (read().played) {
          // Already won: the machine stays on the jackpot above the email form
          this._spun = true;
          this.dialog.dataset.stage = 'won';
          this.game.classList.add('is-final');
          return;
        }
        this.dialog.dataset.stage = 'game';
        this.game.addEventListener('click', (event) => {
          if (event.target.closest('[data-sc-spin]')) this.spin();
        });
      }

      /** Fills the reels with symbol images (first time the popup opens, so nothing loads before). */
      buildReels() {
        if (this._built || !this.strips) return;
        this._built = true;
        const n = FILLERS.length;
        this.strips.forEach((strip, r) => {
          // A long strip of symbols that ends on the jackpot 7; starts on a random filler
          const list = [];
          const len = 16 + r * 6;
          for (let i = 0; i < len; i++) list.push(FILLERS[(i * 5 + r * 3 + Math.floor(Math.random() * n)) % n]);
          // Sprinkle a few 7s in so they fly past while spinning
          [4, 9].forEach((i) => (list[i + r] = JACKPOT));
          list.push(JACKPOT, FILLERS[(r + 2) % n]);
          strip.innerHTML = list.map((k) => `<div class="sc-slots__sym" data-sym="${k}" style="--i:${SYMBOLS.indexOf(k)}"></div>`).join('');
          strip._target = list.length - 2;
        });
        this.place(false);
      }

      /** All the slot icons live in one small image: fetch + decode it once the page is idle,
       *  well before the popup opens, so the reels are ready instantly. */
      warm() {
        const url = this.game.querySelector('[data-sc-machine]')?.dataset.sprite;
        if (!url || this._warm) return;
        this._warm = true;
        const go = () => {
          const img = new Image();
          img.decoding = 'async';
          img.src = url;
          img.decode?.().catch(() => {});
          this._spriteImg = img;
        };
        const idle = (fn) => ('requestIdleCallback' in window ? requestIdleCallback(fn, { timeout: 1500 }) : setTimeout(fn, 300));
        if (document.readyState === 'complete') idle(go);
        else addEventListener('load', () => idle(go), { once: true });
      }

      symHeight() {
        return this.strips[0]?.firstElementChild?.getBoundingClientRect().height || 64;
      }

      /** Positions every reel: at the start (above the jackpot) or on the jackpot. */
      place(final) {
        const h = this.symHeight();
        const win = this.strips[0].parentElement.getBoundingClientRect().height || h * 1.5;
        const offset = (win - h) / 2;
        this.strips.forEach((strip) => {
          const i = final ? strip._target : 1;
          strip.style.transform = `translateY(${offset - i * h}px)`;
        });
      }

      spin() {
        if (this._spun) return;
        this._spun = true;
        this.buildReels();
        const game = this.game;
        const result = game.querySelector('[data-sc-result]');
        game.querySelectorAll('[data-sc-spin]').forEach((b) => (b.disabled = true));
        game.classList.add('is-pulled', 'is-spinning');
        setTimeout(() => game.classList.remove('is-pulled'), 380);
        if (result) result.textContent = '';
        const quick = reduce.matches;
        this.place(false);
        // Next frame: send each reel to the jackpot, the last one slowest (suspense)
        requestAnimationFrame(() =>
          requestAnimationFrame(() => {
            const h = this.symHeight();
            const win = this.strips[0].parentElement.getBoundingClientRect().height || h * 1.5;
            const offset = (win - h) / 2;
            let done = 0;
            this.strips.forEach((strip, r) => {
              const ms = quick ? 300 : 1700 + r * 650 + (r === 2 ? 500 : 0);
              strip.classList.add('is-moving');
              strip.style.transition = `transform ${ms}ms cubic-bezier(0.15, 0.85, 0.25, 1.06)`;
              strip.style.transform = `translateY(${offset - strip._target * h}px)`;
              setTimeout(() => strip.classList.remove('is-moving'), ms * 0.75);
              strip.addEventListener(
                'transitionend',
                () => {
                  if (++done === this.strips.length) this.won();
                },
                { once: true }
              );
            });
          })
        );
      }

      won() {
        const game = this.game;
        game.classList.remove('is-spinning');
        game.classList.add('is-won');
        const result = game.querySelector('[data-sc-result]');
        if (result) result.textContent = game.closest('form')?.querySelector('.sc-slots__won')?.textContent || 'Jackpot!';
        write({ played: Date.now() });
        setTimeout(
          () => {
            // Keep the machine (on the jackpot) above the email form; it goes away once they sign up
            this.dialog.dataset.stage = 'won';
            this.dialog.querySelector('input[type="email"]')?.focus({ preventScroll: true });
          },
          reduce.matches ? 400 : 1900
        );
      }

      open() {
        const img = this.dialog.querySelector('img[data-src]');
        if (img) {
          img.srcset = img.dataset.srcset;
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
        }
        if (this.teaser) this.teaser.hidden = true;
        if (!this.dialog.open) this.dialog.showModal();
        if (this.strips && !this._spun) {
          this.buildReels();
          requestAnimationFrame(() => this.place(false));
        } else if (this.strips && this.dialog.dataset.stage === 'won' && !this._built) {
          this.buildReels();
          requestAnimationFrame(() => this.place(true));
        }
      }

      close() {
        if (this.dialog.open) this.dialog.close();
      }

      async submit(event) {
        event.preventDefault();
        const input = this.form.querySelector('input[type="email"]');
        const error = this.form.querySelector('[data-sc-nl-error]');
        const valid = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(input.value.trim());
        if (error) error.hidden = valid;
        if (!valid) return input.focus();
        const button = this.form.querySelector('button[type="submit"]');
        button?.setAttribute('aria-busy', 'true');
        try {
          const response = await fetch(this.form.action, {
            method: 'POST',
            body: new FormData(this.form),
            headers: { Accept: 'text/html' },
          });
          // Shopify sometimes asks for a captcha: fall back to a normal form post
          if (/\/challenge/.test(response.url)) return this.form.submit();
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const result = doc.querySelector('.sc-nl__dialog');
          if (/customer_posted=true/.test(response.url) || result?.hasAttribute('data-success')) {
            this.dialog.setAttribute('data-success', '');
            write({ subscribed: Date.now() });
          } else if (result?.querySelector('[data-has-error]')) {
            if (error) {
              error.textContent = result.querySelector('[data-has-error]').textContent.trim();
              error.hidden = false;
            }
          } else {
            this.form.submit();
          }
        } catch (e) {
          this.form.submit();
        } finally {
          button?.removeAttribute('aria-busy');
        }
      }
    }
    customElements.define('sc-newsletter-popup', ScNewsletterPopup);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sc-notify-me"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sc-notify-me')) {
    class ScNotifyMe extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this.dialog = this.querySelector('dialog');
        this.form = this.querySelector('form');
        this.opener = this.querySelector('[data-sc-notify-open]');
        if (!this.dialog || !this.form) return;

        // Look exactly like the theme's Add to cart button
        const atc = this.closest('.buy-buttons-block')?.querySelector('.add-to-cart-button');
        if (atc && this.opener) {
          const keep = [...atc.classList].filter((c) => c !== 'add-to-cart-button');
          this.opener.classList.add(...keep);
        }

        this.addEventListener('click', (event) => {
          if (event.target.closest('[data-sc-notify-open]')) return this.open();
          if (event.target.closest('[data-sc-notify-close]') || event.target === this.dialog) this.close();
          const copy = event.target.closest('[data-sc-nl-copy]');
          if (copy) {
            navigator.clipboard?.writeText(copy.dataset.code).then(() => {
              const label = copy.querySelector('[data-sc-nl-copied]');
              if (label) label.textContent = 'Copied';
            });
          }
        });
        this.form.addEventListener('submit', (event) => this.submit(event));
        // Came back from a normal (non-JS) form post
        if (this.dialog.hasAttribute('data-success')) {
          this.done();
          this.open();
        }
      }

      open() {
        const img = this.dialog.querySelector('img[data-src]');
        if (img) {
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
        }
        document.querySelector('sc-newsletter-popup')?.close?.();
        if (!this.dialog.open) this.dialog.showModal();
        this.dialog.querySelector('input[type="email"]')?.focus();
      }

      close() {
        if (this.dialog.open) this.dialog.close();
      }

      done() {
        this.dialog.setAttribute('data-success', '');
        // Signed up: don't show the newsletter popup to them as well
        try {
          const key = 'sc_nl_v1';
          const data = JSON.parse(localStorage.getItem(key) || '{}');
          localStorage.setItem(key, JSON.stringify({ ...data, subscribed: Date.now() }));
        } catch (e) {}
      }

      async submit(event) {
        event.preventDefault();
        const input = this.form.querySelector('input[type="email"]');
        const error = this.form.querySelector('[data-sc-notify-error]');
        const valid = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(input.value.trim());
        if (error) error.hidden = valid;
        if (!valid) return input.focus();
        const button = this.form.querySelector('button[type="submit"]');
        button?.setAttribute('aria-busy', 'true');
        try {
          const response = await fetch(this.form.action, {
            method: 'POST',
            body: new FormData(this.form),
            headers: { Accept: 'text/html' },
          });
          // Shopify sometimes asks for a captcha: fall back to a normal form post
          if (/\/challenge/.test(response.url)) return this.form.submit();
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const result = doc.getElementById(this.dialog.id);
          if (/customer_posted=true/.test(response.url) || result?.hasAttribute('data-success')) {
            this.done();
          } else if (result?.querySelector('[data-has-error]')) {
            if (error) {
              error.textContent = result.querySelector('[data-has-error]').textContent.trim();
              error.hidden = false;
            }
          } else {
            this.form.submit();
          }
        } catch (e) {
          this.form.submit();
        } finally {
          button?.removeAttribute('aria-busy');
        }
      }
    }
    customElements.define('sc-notify-me', ScNotifyMe);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sc-pay-row"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sc-pay-row')) {
    customElements.define(
      'sc-pay-row',
      class extends HTMLElement {
        connectedCallback() {
          this.scope = this.closest('product-form-component') || this.parentElement;
          this.block = this.scope?.querySelector('.accelerated-checkout-block');
          this.btn = this.querySelector('.sc-pay-row__more');
          this.btn.addEventListener('click', () => {
            const n = this.native();
            if (!n) return;
            const target = n.querySelector('a, button') || n;
            target.click();
          });
          this.sync();
          this.mo = new MutationObserver(() => this.sync());
          if (this.scope) this.mo.observe(this.scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-hidden', 'hidden', 'style'] });
        }
        disconnectedCallback() { this.mo?.disconnect(); }
        native() {
          return this.scope?.querySelector('more-payment-options-link, .shopify-payment-button__more-options');
        }
        sync() {
          const n = this.native();
          const usable = !!n && n.getAttribute('aria-hidden') !== 'true' && !n.hidden;
          this.block = this.scope?.querySelector('.accelerated-checkout-block');
          if (this.btn.hidden === usable) this.btn.hidden = !usable;
          this.block?.classList.toggle('sc-pay-row-ready', usable);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sc-quick-view-dialog"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sc-quick-view')) {
    class ScQuickView extends HTMLElement {
      // The quick view markup ships inside a <template> and is only built the first time a
      // shopper reaches for the bag / size bar. Keeps the collection grid light to scroll.
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;

        this.opener = this.querySelector('[data-sc-open]');
        const json = this.querySelector('[data-sc-variants]');
        try {
          this.variants = json ? JSON.parse(json.textContent) : [];
          this.initial = json?.dataset.scSelected ? JSON.parse(json.dataset.scSelected) : [];
        } catch (e) {
          this.variants = [];
          this.initial = [];
        }

        const warm = (event) => {
          if (!event.target.closest?.('[data-sc-open]')) return;
          this.hydrate().then((dialog) => dialog && this.preload(2));
        };
        this.addEventListener('pointerover', warm);
        this.addEventListener('pointerdown', warm);
        this.addEventListener('focusin', warm);
        this.addEventListener('click', (event) => {
          if (!event.target.closest('[data-sc-open]')) return;
          event.preventDefault();
          this.hydrate().then((dialog) => dialog && this.open());
        });

        // Desktop "select size" bar on the card (Elwood style)
        this.hoverBar = this.closest('.sc-card-details')?.querySelector('[data-sc-hover-sizes]');
        this.hoverBar?.addEventListener('pointerover', () => this.hydrate(), { once: true });
        this.hoverBar?.addEventListener('click', (event) => {
          const choice = event.target.closest('[data-sc-quick]');
          if (!choice) return;
          event.preventDefault();
          const fresh = !this.dialog?.isConnected;
          if (fresh) choice.classList.add('is-adding');
          this.hydrate().then((dialog) => {
            if (!dialog) return choice.classList.remove('is-adding');
            fresh ? requestAnimationFrame(() => this.quickAdd(choice)) : this.quickAdd(choice);
          });
        });

        this.update();
      }

      /**
       * Returns (a promise of) the dialog. Cards only ship the variant data; the dialog markup is
       * fetched once from sections/sc-quick-view the first time a shopper reaches for the bag or
       * the size bar. An inline <template> (older markup) is still supported.
       */
      hydrate() {
        if (this.dialog?.isConnected) return Promise.resolve(this.dialog);
        const existing = this.querySelector(':scope > dialog');
        if (existing) return Promise.resolve(this.wire(existing));
        const tpl = this.querySelector('template[data-sc-qv-tpl]');
        if (tpl) {
          tpl.replaceWith(tpl.content.cloneNode(true));
          return Promise.resolve(this.wire(this.querySelector(':scope > dialog')));
        }
        const url = this.dataset.scQvUrl;
        if (!url) return Promise.resolve(null);
        this._loading ??= fetch(url)
          .then((response) => (response.ok ? response.text() : Promise.reject(response.status)))
          .then((html) => {
            const dialog = new DOMParser().parseFromString(html, 'text/html').querySelector('dialog.sc-qv');
            if (!dialog) return null;
            this.prepareFetched(dialog);
            this.append(dialog);
            return this.wire(dialog);
          })
          .catch(() => null)
          .finally(() => {
            this._loading = null;
          });
        return this._loading;
      }

      /** Applies this card's ids, labels and section to a fetched dialog. */
      prepareFetched(dialog) {
        const d = this.dataset;
        if (d.scQvId) dialog.id = d.scQvId;
        const suffix = d.scQvId || String(Math.random()).slice(2);
        dialog.querySelectorAll('form[id]').forEach((form) => (form.id = `${form.id}-${suffix}`));
        if (d.scSection) dialog.querySelectorAll('product-form-component').forEach((c) => (c.dataset.sectionId = d.scSection));
        const details = dialog.querySelector('.sc-qv__details');
        if (details && d.scDetailsLabel) details.textContent = d.scDetailsLabel;
        if (this.hasAttribute('data-sc-no-chart')) {
          dialog.querySelectorAll('[data-sc-chart-open], [data-sc-chart]').forEach((el) => el.remove());
        } else if (d.scChartLabel) {
          dialog.querySelectorAll('.sc-qv__size-guide, .sc-qv__chart-head > span').forEach((el) => (el.textContent = d.scChartLabel));
        }
      }

      /** Wires up a dialog that is now in the page. */
      wire(dialog) {
        if (!dialog) return null;
        this.dialog = dialog;
        this.strip = this.querySelector('[data-sc-strip]');
        this.bar = this.querySelector('[data-sc-progress]');
        this.chart = this.querySelector('[data-sc-chart]');

        this.dialog.addEventListener('click', (event) => {
          const value = event.target.closest('[data-sc-value]');
          if (value) this.select(value);
          if (event.target === this.dialog || event.target.closest('[data-sc-close]')) this.close();
          if (event.target.closest('[data-sc-chart-open]')) this.toggleChart(true);
          if (event.target.closest('[data-sc-chart-close]')) this.toggleChart(false);
          if (event.target.closest('[data-sc-prev]')) this.step(-1);
          if (event.target.closest('[data-sc-next]')) this.step(1);
        });

        this.dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('sc-qv-open');
          this.toggleChart(false);
          // Let the product card ignore this click, then allow card navigation again
          setTimeout(() => this.card?.removeAttribute('data-no-navigation'), 0);
        });

        // Close after a successful add; the theme then opens the cart drawer
        this.dialog.addEventListener('shopify:cart:lines-update', (event) => {
          const done = (result) => {
            const ok = !result?.detail?.didError;
            if (this.hoverBar) {
              this.hoverBar.classList.remove('is-adding');
              this.hoverBar.querySelectorAll('.is-adding').forEach((b) => b.classList.remove('is-adding'));
              if (ok) {
                this.hoverBar.classList.add('is-added');
                setTimeout(() => this.hoverBar?.classList.remove('is-added'), 1500);
              }
            }
            if (ok && this.dialog.open) setTimeout(() => this.close(), 300);
          };
          if (event.promise?.then) event.promise.then(done).catch(() => done({ detail: { didError: true } }));
          else setTimeout(() => done({}), 600);
        });

        // No "fly to cart" animation from the quick view
        this.querySelectorAll('add-to-cart-component').forEach((c) => {
          c.dataset.addToCartAnimation = 'false';
        });

        // Image strip: throttle progress updates to one per frame
        this.strip?.addEventListener(
          'scroll',
          () => {
            if (this._raf) return;
            this._raf = requestAnimationFrame(() => {
              this._raf = null;
              this.updateProgress();
            });
          },
          { passive: true }
        );

        this.update();
        return this.dialog;
      }

      preload(count) {
        [...this.querySelectorAll('.sc-qv__slide img')].slice(0, count).forEach((img, i) => {
          img.loading = 'eager';
          if (i === 0) img.fetchPriority = 'high';
        });
      }

      step(direction) {
        if (!this.strip) return;
        const slide = this.strip.querySelector('.sc-qv__slide');
        const gap = parseFloat(getComputedStyle(this.strip).columnGap) || 0;
        const amount = slide ? slide.getBoundingClientRect().width + gap : this.strip.clientWidth;
        this.strip.scrollBy({ left: amount * direction, behavior: 'smooth' });
      }

      toggleChart(show) {
        if (!this.chart) return;
        this.chart.hidden = !show;
        this.querySelectorAll('[data-sc-chart-open]').forEach((b) => b.setAttribute('aria-expanded', String(show)));
        if (show) {
          this.chart.querySelector('img')?.setAttribute('loading', 'eager');
          this.dialog.scrollTop = 0;
          this.chart.querySelector('[data-sc-chart-close]')?.focus();
        }
      }

      quickAdd(choice) {
        const index = Number(choice.dataset.scIndex);
        const group = this.querySelectorAll('[data-sc-option]')[index];
        if (group) {
          const match = [...group.querySelectorAll('[data-sc-value]')].find((b) => b.dataset.scValue === choice.dataset.scQuick);
          if (match) this.select(match);
        }
        const button = this.querySelector('.sc-qv__atc');
        const form = this.querySelector('form[data-type="add-to-cart-form"]');
        if (!form || !button || button.disabled) return;

        this.hoverBar?.classList.add('is-adding');
        choice.classList.add('is-adding');
        form.requestSubmit();
      }

      get card() {
        return this.closest('product-card');
      }

      open() {
        if (!this.dialog || this.dialog.open) return;
        this.card?.setAttribute('data-no-navigation', '');
        this.dialog.showModal();
        document.documentElement.classList.add('sc-qv-open');
        if (this.strip) this.strip.scrollLeft = 0;
        // Load the first three photos now; the rest load as they are swiped into view
        this.preload(3);
        requestAnimationFrame(() => this.updateProgress());
      }

      close() {
        if (this.dialog?.open) this.dialog.close();
      }

      updateProgress() {
        if (!this.strip || !this.bar) return;
        const { scrollWidth, clientWidth, scrollLeft } = this.strip;
        const visible = scrollWidth > 0 ? Math.min(1, clientWidth / scrollWidth) : 1;
        const max = Math.max(1, scrollWidth - clientWidth);
        const travel = (1 - visible) / visible;
        this.bar.style.setProperty('--sc-qv-thumb', `${visible * 100}%`);
        this.bar.style.setProperty('--sc-qv-pos', `${(scrollLeft / max) * travel * 100}%`);
        const prev = this.querySelector('[data-sc-prev]');
        const next = this.querySelector('[data-sc-next]');
        if (prev) prev.disabled = scrollLeft <= 2;
        if (next) next.disabled = scrollLeft >= max - 2;
      }

      select(button) {
        const group = button.closest('[data-sc-option]');
        group.querySelectorAll('[data-sc-value]').forEach((b) => b.setAttribute('aria-pressed', String(b === button)));
        this.update();
      }

      selection() {
        const groups = [...this.querySelectorAll('[data-sc-option]')];
        if (!groups.length) return (this.initial || []).slice();
        return groups.map(
          (group) => group.querySelector('[aria-pressed="true"]')?.dataset.scValue ?? null
        );
      }

      find(values) {
        return this.variants.find((v) => v.options.every((o, i) => o === values[i]));
      }

      update() {
        const selected = this.selection();
        const variant = this.find(selected);
        const input = this.querySelector('input[name="id"]');
        const button = this.querySelector('.sc-qv__atc');
        const label = this.querySelector('.sc-qv__atc-label');
        const price = this.querySelector('[data-sc-price]');

        if (variant && input) {
          input.value = variant.id;
          if (price) price.innerHTML = variant.compare ? `${variant.price} <s>${variant.compare}</s>` : variant.price;
        }

        const canAdd = Boolean(variant && variant.available);
        if (button) button.disabled = !canAdd;
        if (label) label.textContent = canAdd ? label.dataset.add : label.dataset.soldout;

        this.querySelectorAll('[data-sc-option]').forEach((group, index) => {
          group.querySelectorAll('[data-sc-value]').forEach((b) => {
            const test = selected.slice();
            test[index] = b.dataset.scValue;
            const match = this.find(test);
            b.classList.toggle('is-unavailable', !(match && match.available));
          });
        });

        // Keep the desktop size bar in sync (sold-out sizes crossed out)
        this.hoverBar?.querySelectorAll('[data-sc-quick]').forEach((b) => {
          const index = Number(b.dataset.scIndex);
          if (Number.isNaN(index) || b.dataset.scIndex === '') return;
          const test = selected.slice();
          test[index] = b.dataset.scQuick;
          const match = this.find(test);
          const available = Boolean(match && match.available);
          b.classList.toggle('is-unavailable', !available);
          b.disabled = !available;
        });
      }
    }

    customElements.define('sc-quick-view', ScQuickView);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sc-size-chart"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__scSizeChart) return;
    window.__scSizeChart = true;
    document.addEventListener('click', (event) => {
      const open = event.target.closest('[data-sc-size-chart-open]');
      if (open) {
        event.preventDefault();
        event.stopPropagation();
        const dialog = document.getElementById(open.dataset.scSizeChartOpen);
        dialog?.showModal();
        return;
      }
      const dialog = event.target.closest('dialog.sc-size-chart');
      if (dialog && (event.target === dialog || event.target.closest('[data-sc-size-chart-close]'))) dialog.close();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sc-size-finder"] && !Shopify.designMode) return;
  try {
    (() => {
  const SF = (() => {
    const ORDER = ['XXS','XS','S','M','L','XL','2XL','3XL','4XL'];
    const norm = (v) => {
      let s = String(v || '').toUpperCase().replace(/[\s\-_.]/g, '');
      const map = { XXSMALL:'XXS', XSMALL:'XS', EXTRASMALL:'XS', SMALL:'S', MEDIUM:'M', LARGE:'L', XLARGE:'XL', EXTRALARGE:'XL', XXL:'2XL', XXLARGE:'2XL', XXXL:'3XL', XXXXL:'4XL', ONESIZE:'OS' };
      return map[s] || s;
    };
    const T = {
      men:   { chest:{XS:33,S:36,M:39,L:42,XL:45,'2XL':48,'3XL':51}, waist:{XS:27,S:29.5,M:32,L:35,XL:38,'2XL':41,'3XL':44}, hip:{XS:36,S:38.5,M:41,L:43.5,XL:46,'2XL':48.5,'3XL':51} },
      women: { chest:{XS:32,S:34,M:36,L:38.5,XL:41.5,'2XL':44.5,'3XL':47.5}, waist:{XS:25,S:27,M:29,L:31.5,XL:34.5,'2XL':37.5,'3XL':40.5}, hip:{XS:35,S:37,M:39,L:41.5,XL:44.5,'2XL':47.5,'3XL':50.5} }
    };
    const CUP = { AA:0.5, A:1, B:2, C:3, D:4, 'DD/E':5, 'DDD/F':6, 'DDDD/G':7, H:8, I:9, J:10, K:11 };
    function body(p) {
      const h = p.heightCm, w = p.weightKg, age = p.age || 30;
      const ageAdj = Math.max(0, Math.min(age, 65) - 25);
      let chest, waist, hip;
      if (p.gender === 'women') {
        chest = 92 * Math.pow(w / 62, 0.55) * Math.pow(165 / h, 0.2);
        if (p.band && CUP[p.cup] != null) {
          const braIn = Number(p.band) + CUP[p.cup];
          chest = 0.3 * chest + 0.7 * braIn * 2.54;
        }
        waist = 72 * Math.pow(w / 62, 0.9) * Math.pow(165 / h, 0.6) + ({flat:-3,medium:0,round:5}[p.stomach] || 0) + ageAdj * 0.1;
        hip = 100 * Math.pow(w / 62, 0.6) * Math.pow(165 / h, 0.2) + ({narrow:-4,medium:0,wide:5}[p.hips] || 0);
      } else {
        chest = 100 * Math.pow(w / 77, 0.5) * Math.pow(178 / h, 0.25) + ({slim:-3,medium:0,muscular:4}[p.torso] || 0) + ({flat:-1,medium:0,round:2}[p.stomach] || 0);
        waist = 86 * Math.pow(w / 77, 0.9) * Math.pow(178 / h, 0.6) + ({flat:-4,medium:0,round:6}[p.stomach] || 0) + ageAdj * 0.12;
        hip = 103 * Math.pow(w / 77, 0.6) * Math.pow(178 / h, 0.3) + ({thin:-3,medium:0,large:4}[p.thighs] || 0);
      }
      return { chest: chest / 2.54, waist: waist / 2.54, hip: hip / 2.54 };
    }
    // position of value along ascending array (float index, extrapolated)
    function pos(arr, v) {
      const n = arr.length;
      if (n === 1) return 0;
      if (v <= arr[0]) return (v - arr[0]) / Math.max(0.5, arr[1] - arr[0]);
      if (v >= arr[n - 1]) return n - 1 + (v - arr[n - 1]) / Math.max(0.5, arr[n - 1] - arr[n - 2]);
      for (let i = 0; i < n - 1; i++) if (v <= arr[i + 1]) return i + (v - arr[i]) / Math.max(0.01, arr[i + 1] - arr[i]);
      return n - 1;
    }
    function measureIndex(sizes, data, key, table, mult, bodyVal) {
      const rows = sizes.map((s) => ({ s, g: data[s] && data[s][key] != null ? Number(data[s][key]) * mult : null })).filter((r) => r.g != null);
      if (!rows.length) return null;
      // Anchor the chart on its middle size (M if present), then blend the chart's own
      // grading with the standard body size for each label.
      const pref = ['M', 'L', 'S', 'XL', 'XS', '2XL', '3XL'];
      const anchor = pref.map((l) => rows.find((r) => r.s === l && table[l] != null)).find(Boolean);
      const ease = anchor ? anchor.g - table[anchor.s] : 0;
      let eq = rows.map((r) => (table[r.s] != null ? 0.5 * (r.g - ease) + 0.5 * table[r.s] : r.g - ease));
      for (let i = 1; i < eq.length; i++) if (eq[i] <= eq[i - 1]) eq[i] = eq[i - 1] + 0.25; // keep ascending
      const p = pos(eq, bodyVal);
      // map row index back to index in sizes list
      const idx = rows.map((r) => sizes.indexOf(r.s));
      const lo = Math.max(0, Math.min(idx.length - 1, Math.floor(p)));
      const hi = Math.min(idx.length - 1, lo + 1);
      const frac = p - Math.floor(p);
      const sizePos = p < 0 ? idx[0] + p : p > idx.length - 1 ? idx[idx.length - 1] + (p - (idx.length - 1)) : idx[lo] + (idx[hi] - idx[lo]) * frac;
      return sizePos;
    }
    function recommend(profile, product) {
      const d = product.data || {};
      const sizesRaw = product.sizes; // product option values in order
      const sizes = sizesRaw.map(norm);
      const dataN = {};
      Object.keys(d.sizes || {}).forEach((k) => (dataN[norm(k)] = d.sizes[k]));
      const table = T[d.gender === 'women' ? 'women' : 'men'];
      const b = body(profile);
      let p;
      if (d.type === 'bottom') {
        const pw = measureIndex(sizes, dataN, 'waist', table.waist, 1, b.waist);
        const ph = measureIndex(sizes, dataN, 'hip', table.hip, 1, b.hip);
        p = Math.max(pw ?? -99, ph ?? -99);
        if (p === -99) return null;
      } else {
        const mult = d.measure === 'chest_flat' ? 2 : 1;
        p = measureIndex(sizes, dataN, 'chest', table.chest, mult, b.chest);
        if (p == null) return null;
      }
      const fp = Number(product.fit);
      if (!isNaN(fp) && product.fit !== null && product.fit !== '') p += ((50 - fp) / 50) * 0.6;
      const tall = profile.gender === 'women' ? profile.heightCm >= 173 : profile.heightCm >= 185;
      const frac = p - Math.floor(p);
      let ideal = frac >= 0.4 && frac <= 0.6 ? (tall ? Math.ceil(p) : Math.floor(p)) : Math.round(p);
      const n = sizes.length;
      const range = p < -0.6 ? 'below' : p > n - 1 + 0.6 ? 'above' : null;
      ideal = Math.max(0, Math.min(n - 1, ideal));
      return { ideal, slimmer: ideal > 0 ? ideal - 1 : null, looser: ideal < n - 1 ? ideal + 1 : null, p, range, body: b };
    }
    return { norm, body, recommend };
  })();
  /* ---------- figures (original line drawings) ---------- */
  const SF_FIG = (() => {
    let uid = 0;
    const INK = '#2b2b2b';
    const GARM = '#8c8c8c';
    const line = `stroke="${INK}" stroke-width="1.1" fill="none" stroke-linecap="round" stroke-linejoin="round"`;
    const dash = `stroke="${INK}" stroke-width="1" fill="none" stroke-dasharray="2.4 2.2" stroke-linecap="round"`;
    const svg = (inner) => `<svg viewBox="0 0 120 160" aria-hidden="true" focusable="false">${inner}</svg>`;
    // body silhouette filled white, garments clipped to it, outline on top
    const body = (sil, garments, extra) => {
      const id = 'scsf' + ++uid;
      return svg(`<defs><clipPath id="${id}"><path d="${sil}"/></clipPath></defs>
        <path d="${sil}" fill="#fff"/>
        <g clip-path="url(#${id})">${garments.map((g) => `<path d="${g}" fill="${GARM}"/>`).join('')}</g>
        <path d="${sil}" ${line}/>${extra || ''}`);
    };

    /* side view, facing right — stomach */
    function side(b, women) {
      const bx = (v) => v + b;
      const front = women
        ? `C70 41 72 45 76 51 C78 56 75 61 70 62 C${bx(70)} 70 ${bx(71)} 86 ${68 + b * 0.4} 100`
        : `C71 43 73 50 72 57 C71 61 70 63 70 65 C${bx(70)} 72 ${bx(71)} 88 ${68 + b * 0.4} 100`;
      const sil = `M58 5 C66 5 71 11 70 19 L72 24 L70 25 C70 29 67 32 63 33 L65 39 ${front}
        C67 110 67 116 66 124 C65 138 64 150 63 160 L48 160 C48 148 48 138 47 126
        C44 120 41.5 112 43 102 C45.5 92 48 80 47 70 C45 58 46 46 52 40 C53 37 53 34 53 31 C51 28 50 24 50 19 C50 11 52 5 58 5 Z`;
      const garments = women ? ['M0 46 H120 V61 H0 Z', 'M0 97 H120 V112 L0 116 Z'] : ['M0 98 H120 V130 H0 Z'];
      const arm = `<path d="M56.5 44 C54.5 58 55 72 56.5 86 C57 96 57.5 102 58 107 C59 109.5 61.2 108.5 61.2 106 C61 96 61.6 86 61.8 76 C62.2 64 62.4 54 61.4 46 C60 42.5 57.8 42.5 56.5 44 Z" fill="#fff" ${line}/>`;
      const d = `<path d="M${bx(74)} 64 C${bx(76.5)} 72 ${bx(76.5)} 86 ${72 + b * 0.4} 99" ${dash}/>`;
      return body(sil, garments, arm + d);
    }

    /* front view, upper body — torso */
    function torso(kind) {
      const k = { slim: { sh: 25, ch: 19, wa: 16, arm: 6.5, pec: 3 }, medium: { sh: 28, ch: 22, wa: 18.5, arm: 7.5, pec: 4 }, muscular: { sh: 32, ch: 26, wa: 19, arm: 9.5, pec: 7 } }[kind];
      const L = (x) => 60 - x, R = (x) => 60 + x;
      const sil = `M60 5 C67 5 71 11 71 19 C71 27 67 32 65 33 L65 39
        C70 41 ${R(k.sh - 6)} 42 ${R(k.sh - 2)} 45 C${R(k.sh + 1)} 48 ${R(k.ch)} 54 ${R(k.ch)} 60
        C${R(k.ch)} 72 ${R(k.wa)} 82 ${R(k.wa)} 96 L${R(k.wa + 1)} 104 C${R(k.wa + 3)} 120 ${R(k.wa + 3)} 140 ${R(k.wa + 2)} 160
        L62.5 160 C62.5 145 62.5 135 62 124 Q60 118 58 124 C57.5 135 57.5 145 57.5 160 L${L(k.wa + 2)} 160
        C${L(k.wa + 3)} 140 ${L(k.wa + 3)} 120 ${L(k.wa + 1)} 104 L${L(k.wa)} 96 C${L(k.wa)} 82 ${L(k.ch)} 72 ${L(k.ch)} 60
        C${L(k.ch)} 54 ${L(k.sh + 1)} 48 ${L(k.sh - 2)} 45 C${L(k.sh - 6)} 42 50 41 55 39 L55 33 C53 32 49 27 49 19 C49 11 53 5 60 5 Z`;
      const armL = `M${L(k.sh - 2)} 45 C${L(k.sh + 2)} 50 ${L(k.sh + 2.5)} 70 ${L(k.sh + 1.5)} 92 L${L(k.sh + 1)} 116 C${L(k.sh)} 120 ${L(k.sh - k.arm + 1)} 120 ${L(k.sh - k.arm)} 116 C${L(k.sh - k.arm - 0.5)} 98 ${L(k.sh - k.arm - 1)} 74 ${L(k.ch)} 60 C${L(k.ch)} 53 ${L(k.sh - 1)} 48 ${L(k.sh - 2)} 45 Z`;
      const armR = armL.replace(/(-?\d+(?:\.\d+)?) (-?\d+(?:\.\d+)?)/g, (m, x, y) => `${(120 - parseFloat(x)).toFixed(1)} ${y}`);
      const pecs = `<path d="M${L(k.ch - 3)} 66 C${L(k.ch - 7)} ${68 + k.pec} 54 ${68 + k.pec} 59.5 ${65 + k.pec / 2} M${R(k.ch - 3)} 66 C${R(k.ch - 7)} ${68 + k.pec} 66 ${68 + k.pec} 60.5 ${65 + k.pec / 2}" ${line}/>`;
      const abs = kind === 'muscular' ? `<path d="M60 76 V92 M55 81 Q60 82.5 65 81 M55.5 87 Q60 88.5 64.5 87" stroke="${INK}" stroke-width="0.7" fill="none" stroke-linecap="round"/>` : '';
      const navel = `<ellipse cx="60" cy="96" rx="0.8" ry="1.2" fill="${INK}"/>`;
      const d = `<path d="M${L(k.ch + 4)} 58 C${L(k.ch + 6.5)} 66 ${L(k.ch + 6.5)} 76 ${L(k.ch + 4)} 84 M${R(k.ch + 4)} 58 C${R(k.ch + 6.5)} 66 ${R(k.ch + 6.5)} 76 ${R(k.ch + 4)} 84" ${dash}/>`;
      return body(sil, ['M0 102 H120 V142 H0 Z'], pecs + abs + navel +
        `<path d="${armL}" fill="#fff" ${line}/><path d="${armR}" fill="#fff" ${line}/>` + d);
    }

    /* front view, lower body — thighs (men) / hips (women) */
    function lower(level, women) {
      const wa = women ? 15 : 19;
      const hip = (women ? [24, 27, 31] : [23, 25.5, 28.5])[level];
      const th = (women ? [20, 23, 27] : [19.5, 22.5, 26])[level];
      const L = (x) => 60 - x, R = (x) => 60 + x;
      const sil = `M${L(wa)} 0 C${L(wa)} 18 ${L(hip)} 32 ${L(hip)} 50 C${L(hip)} 72 ${L(th)} 96 ${L(th - 1)} 116
        C${L(th - 3)} 132 ${L(16)} 146 ${L(15)} 160 L55.5 160 C55.5 140 56 118 57.5 96 Q60 88 62.5 96
        C64 118 64.5 140 64.5 160 L${R(15)} 160 C${R(16)} 146 ${R(th - 3)} 132 ${R(th - 1)} 116
        C${R(th)} 96 ${R(hip)} 72 ${R(hip)} 50 C${R(hip)} 32 ${R(wa)} 18 ${R(wa)} 0 Z`;
      const garments = women ? ['M0 34 H120 V46 L67 76 L60 78 L53 76 L0 46 Z'] : ['M0 26 H120 V112 L63 112 L60 92 L57 112 L0 112 Z'];
      const navel = `<ellipse cx="60" cy="${women ? 16 : 12}" rx="0.8" ry="1.2" fill="${INK}"/>`;
      const y0 = women ? 34 : 50, y1 = women ? 70 : 104;
      const ho = women ? hip : th + 1;
      const d = `<path d="M${L(hip + 4)} ${y0} C${L(ho + 6.5)} ${y0 + 14} ${L(ho + 6.5)} ${y1 - 14} ${L(ho + 4)} ${y1} M${R(hip + 4)} ${y0} C${R(ho + 6.5)} ${y0 + 14} ${R(ho + 6.5)} ${y1 - 14} ${R(ho + 4)} ${y1}" ${dash}/>`;
      return body(sil, garments, navel + d);
    }

    return {
      stomach: (v, women) => side({ flat: 0, medium: 4, round: 8 }[v], women),
      torso: (v) => torso(v),
      thighs: (v) => lower({ thin: 0, medium: 1, large: 2 }[v], false),
      hips: (v) => lower({ narrow: 0, medium: 1, wide: 2 }[v], true),
    };
  })();

  const SF_STORE = 'sc_size_profile_v1';
  const SF_STEPS = {
    men: [
      { key: 'stomach', title: 'Select your stomach shape', options: ['flat', 'medium', 'round'] },
      { key: 'torso', title: 'Select your torso shape', options: ['slim', 'medium', 'muscular'] },
      { key: 'thighs', title: 'Select your thigh shape', options: ['thin', 'medium', 'large'] },
    ],
    women: [
      { key: 'stomach', title: 'Select your stomach shape', options: ['flat', 'medium', 'round'] },
      { key: 'hips', title: 'Select your hip shape', options: ['narrow', 'medium', 'wide'] },
      { key: 'chest', title: 'Select your chest size' },
    ],
  };
  const SF_BANDS = [28, 30, 32, 34, 36, 38, 40, 42, 44, 46, 48];
  const SF_CUPS = ['AA', 'A', 'B', 'C', 'D', 'DD/E', 'DDD/F', 'DDDD/G', 'H', 'I', 'J', 'K'];
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

  function sfLoad() {
    try { return JSON.parse(localStorage.getItem(SF_STORE) || 'null'); } catch (e) { return null; }
  }
  function sfSave(p) {
    try { localStorage.setItem(SF_STORE, JSON.stringify(p)); } catch (e) {}
  }
  function sfClear() {
    try { localStorage.removeItem(SF_STORE); } catch (e) {}
  }

  class ScSizeFinder extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      try {
        this.product = JSON.parse(this.querySelector('[data-sf-product]').textContent);
      } catch (e) {
        return;
      }
      this.dialog = this.querySelector('dialog.sc-sf');
      this.body = this.querySelector('[data-sf-body]');
      this.backBtn = this.querySelector('[data-sf-back]');
      const saved = sfLoad();
      this.state = { step: 'basics', shapeIndex: 0, units: { h: 'imperial', w: 'imperial' }, profile: saved || {}, tab: 'ideal' };

      // keep quiz inputs from reaching the variant picker
      ['change', 'input'].forEach((t) => this.addEventListener(t, (e) => e.stopPropagation()));
      this.dialog.addEventListener('click', (e) => this.onClick(e));
      this.dialog.addEventListener('close', () => document.documentElement.classList.remove('sc-sf-open'));
      this.dialog.addEventListener('cancel', () => {});
      this.dialog.addEventListener('mousedown', (e) => { if (e.target === this.dialog) this.close(); });
      this.updateTrigger();
      const host = this.closest('variant-picker') || this.parentElement;
      if (host) {
        let raf = 0;
        this._mo = new MutationObserver(() => {
          if (raf) return;
          raf = requestAnimationFrame(() => { raf = 0; this.updateTrigger(); });
        });
        this._mo.observe(host, { childList: true, subtree: true });
      }
    }

    disconnectedCallback() { this._mo?.disconnect(); }

    open() {
      const saved = sfLoad();
      if (saved && saved.heightCm && saved.weightKg && saved.gender) {
        this.state.profile = saved;
        this.state.step = 'result';
        this.state.tab = 'ideal';
      } else {
        this.state.step = 'basics';
      }
      this.render();
      if (!this.dialog.open) this.dialog.showModal();
      document.documentElement.classList.add('sc-sf-open');
    }

    close() { if (this.dialog.open) this.dialog.close(); }

    steps() { return SF_STEPS[this.state.profile.gender === 'women' ? 'women' : 'men']; }

    render() {
      const s = this.state;
      this.backBtn.hidden = s.step === 'basics' || s.step === 'result';
      if (s.step === 'basics') this.body.innerHTML = this.viewBasics();
      else if (s.step === 'shape') this.body.innerHTML = this.viewShape();
      else this.body.innerHTML = this.viewResult();
      this.dialog.scrollTop = 0;
      if (s.step === 'result') this.loadSimilar();
    }

    /* ---------- step 1 ---------- */
    viewBasics() {
      const p = this.state.profile, u = this.state.units;
      let hA = '', hB = '', wv = '';
      if (p.heightCm) {
        if (u.h === 'metric') hA = Math.round(p.heightCm);
        else { const tin = p.heightCm / 2.54; hA = Math.floor(tin / 12); hB = Math.round(tin - hA * 12); }
      }
      if (p.weightKg) wv = u.w === 'metric' ? Math.round(p.weightKg) : Math.round(p.weightKg * 2.20462);
      const unitBtns = (group, a, b) => `<span class="sc-sf__units">
          <button type="button" class="sc-sf__unit" data-unit="${group}:metric" aria-pressed="${u[group] === 'metric'}">${a}</button>
          <button type="button" class="sc-sf__unit" data-unit="${group}:imperial" aria-pressed="${u[group] === 'imperial'}">${b}</button>
        </span>`;
      const heightFields = u.h === 'metric'
        ? `<div class="sc-sf__input"><input type="number" inputmode="numeric" name="h_cm" placeholder="ex: 178" value="${hA}" aria-label="Height in centimeters">${unitBtns('h', 'cm', 'feet')}</div>`
        : `<div class="sc-sf__row">
             <div class="sc-sf__input"><input type="number" inputmode="numeric" name="h_ft" placeholder="ex: 5'" value="${hA}" aria-label="Height feet"></div>
             <div class="sc-sf__input"><input type="number" inputmode="numeric" name="h_in" placeholder='ex: 9"' value="${hB}" aria-label="Height inches">${unitBtns('h', 'cm', 'feet')}</div>
           </div>`;
      const g = p.gender;
      return `
        <h2 class="sc-sf__title">Find your size for each of our products</h2>
        <p class="sc-sf__sub">First, a few questions to get to know you better.</p>
        <div class="sc-sf__field"><span class="sc-sf__label">Height*</span>${heightFields}</div>
        <div class="sc-sf__field"><span class="sc-sf__label">Weight*</span>
          <div class="sc-sf__input"><input type="number" inputmode="numeric" name="w" placeholder="ex: ${u.w === 'metric' ? '70' : '154'}" value="${wv}" aria-label="Weight">${unitBtns('w', 'kg', 'lbs')}</div>
        </div>
        <div class="sc-sf__field"><span class="sc-sf__label">Age*</span>
          <div class="sc-sf__input"><input type="number" inputmode="numeric" name="age" placeholder="ex: 30 years old" value="${p.age || ''}" aria-label="Age"></div>
        </div>
        <div class="sc-sf__field"><span class="sc-sf__label">Shopping for</span>
          <div class="sc-sf__choices">
            <button type="button" class="sc-sf__choice" data-gender="women" aria-pressed="${g === 'women'}">Women</button>
            <button type="button" class="sc-sf__choice" data-gender="men" aria-pressed="${g === 'men'}">Men</button>
          </div>
        </div>
        <p class="sc-sf__error" data-sf-error hidden></p>
        <button type="button" class="sc-sf__cta" data-sf-next="basics">Continue</button>`;
    }

    readBasics() {
      const v = (n) => { const el = this.body.querySelector(`[name="${n}"]`); return el ? parseFloat(el.value) : NaN; };
      const p = this.state.profile, u = this.state.units;
      let hcm = u.h === 'metric' ? v('h_cm') : ((v('h_ft') || 0) * 12 + (v('h_in') || 0)) * 2.54;
      const w = v('w');
      const wkg = u.w === 'metric' ? w : w / 2.20462;
      const age = v('age');
      if (hcm > 0) p.heightCm = hcm;
      if (wkg > 0) p.weightKg = wkg;
      if (age > 0) p.age = age;
      const errs = [];
      if (!(hcm >= 120 && hcm <= 230)) errs.push('Please enter your height.');
      if (!(wkg >= 30 && wkg <= 250)) errs.push('Please enter your weight.');
      if (!(age >= 10 && age <= 110)) errs.push('Please enter your age.');
      if (!p.gender) errs.push('Please choose who you are shopping for.');
      return errs;
    }

    /* ---------- step 2 ---------- */
    viewShape() {
      const steps = this.steps();
      const i = this.state.shapeIndex;
      const step = steps[i];
      const p = this.state.profile;
      const women = p.gender === 'women';
      const dots = `<div class="sc-sf__dots">${steps.map((_, k) => `<span class="${k === i ? 'is-active' : ''}"></span>`).join('')}</div>`;
      const last = i === steps.length - 1;
      if (step.key === 'chest') {
        return `
          <h2 class="sc-sf__title">${step.title}</h2>
          <p class="sc-sf__sub">Refer to your bra size (US).</p>
          <div class="sc-sf__field"><span class="sc-sf__label">Band size</span>
            <div class="sc-sf__bra-grid">${SF_BANDS.map((b) => `<button type="button" class="sc-sf__bra" data-band="${b}" aria-pressed="${Number(p.band) === b}">${b}</button>`).join('')}</div>
          </div>
          <div class="sc-sf__field"><span class="sc-sf__label">Cup size</span>
            <div class="sc-sf__bra-grid">${SF_CUPS.map((c) => `<button type="button" class="sc-sf__bra" data-cup="${c}" aria-pressed="${p.cup === c}">${c}</button>`).join('')}</div>
          </div>
          ${dots}
          <button type="button" class="sc-sf__cta" data-sf-next="shape" ${p.band && p.cup ? '' : 'disabled'}>Find my ideal size</button>
          <button type="button" class="sc-sf__link" data-sf-skip-chest>I prefer not to answer</button>`;
      }
      const cards = step.options.map((o) => `
        <button type="button" class="sc-sf__card" data-shape="${step.key}:${o}" aria-pressed="${p[step.key] === o}">
          ${this.figure(step.key, o, women)}<span>${o}</span>
        </button>`).join('');
      return `
        <h2 class="sc-sf__title">${step.title}</h2>
        <p class="sc-sf__sub">This helps us understand your body shape.</p>
        <div class="sc-sf__cards">${cards}</div>
        ${dots}
        <button type="button" class="sc-sf__cta" data-sf-next="shape" ${p[step.key] ? '' : 'disabled'}>${last ? 'Find my ideal size' : 'Continue'}</button>`;
    }

    figure(key, option, women) {
      const imgs = this.product.images || {};
      const url = imgs[`${women ? 'women' : 'men'}_${key}_${option}`];
      if (url) return `<img class="sc-sf__card-img" src="${esc(url)}" alt="" loading="lazy">`;
      return SF_FIG[key](option, women);
    }

    /* ---------- trigger label ---------- */
    updateTrigger() {
      const saved = sfLoad();
      let text = 'Find your perfect size';
      if (saved && saved.heightCm && saved.weightKg && saved.gender) {
        const r = SF.recommend(saved, { data: this.product.data, sizes: this.product.sizes, fit: this.product.fit });
        if (r) text = `Recommended size: ${this.product.sizes[r.ideal]}`;
      }
      document.querySelectorAll(`[data-sc-sf-open="${this.dialog.id}"] [data-sf-label]`).forEach((el) => {
        if (el.textContent !== text) el.textContent = text;
      });
    }

    /* ---------- result ---------- */
    variantFor(sizeIndex) {
      const pr = this.product;
      const label = pr.sizes[sizeIndex];
      const oi = pr.optionIndex;
      const matches = pr.variants.filter((v) => v.options[oi] === label);
      const same = matches.find((v) => v.options.every((o, k) => k === oi || o === pr.selected[k]));
      return (same && same.available ? same : matches.find((v) => v.available)) || same || matches[0] || null;
    }

    compute() {
      const pr = this.product;
      return SF.recommend(this.state.profile, { data: pr.data, sizes: pr.sizes, fit: pr.fit });
    }

    viewResult() {
      const r = this.compute();
      this.result = r;
      if (!r) {
        return `<h2 class="sc-sf__title">Recommended size</h2>
          <p class="sc-sf__msg">We don't have enough sizing details for this item yet. Please check the size chart.</p>
          <button type="button" class="sc-sf__link" data-sf-restart>Start over</button>`;
      }
      const pr = this.product;
      const tab = this.state.tab;
      let idx = r.ideal;
      if (tab === 'slimmer' && r.slimmer != null) idx = r.slimmer;
      if (tab === 'looser' && r.looser != null) idx = r.looser;
      const label = pr.sizes[idx];
      const variant = this.variantFor(idx);
      const available = !!(variant && variant.available);
      this.current = { idx, label, variant, available };

      let msg;
      if (!available) msg = 'Unfortunately, the selected size is out of stock.';
      else if (tab === 'ideal') {
        if (r.range === 'below') msg = `Size ${esc(label)} is our smallest size in this item and may fit loose on you.`;
        else if (r.range === 'above') msg = `Size ${esc(label)} is our largest size in this item and may fit snug on you.`;
        else msg = `Based on your body shape, size ${esc(label)} is the best fit for you in this item.`;
      } else if (tab === 'slimmer') msg = `Size ${esc(label)} will fit closer to the body than your ideal size.`;
      else msg = `Based on your body shape, size ${esc(label)} will fit more relaxed than your ideal size.`;

      const tabBtn = (kind, text, i) => `<button type="button" class="sc-sf__tab" data-kind="${kind}" data-tab="${kind}" aria-pressed="${tab === kind}" ${i == null ? 'disabled' : ''}>${i == null ? '' : text}</button>`;
      const showBadge = tab === 'ideal' && !r.range;
      const sum = this.summary();

      return `
        <h2 class="sc-sf__title">${available ? 'Recommended size' : 'Your recommended size is unavailable:'}</h2>
        <div class="sc-sf__result-size${available ? '' : ' is-unavailable'}">${esc(label)}</div>
        <div class="sc-sf__badge">${showBadge ? `Perfect size <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><circle cx="8" cy="8" r="8" fill="#4a7a4a"/><path d="M4.5 8.2l2.3 2.2 4.7-4.8" stroke="#fff" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>` : ''}</div>
        <div class="sc-sf__tabs" role="group" aria-label="Fit">
          ${tabBtn('slimmer', 'Slimmer fit', r.slimmer)}
          ${tabBtn('ideal', 'Ideal', r.ideal)}
          ${tabBtn('looser', 'Looser fit', r.looser)}
        </div>
        <p class="sc-sf__msg">${msg}</p>
        ${available
          ? `<button type="button" class="sc-sf__cta" data-sf-add>Add size ${esc(label)} to cart</button>`
          : `<hr class="sc-sf__hr"><p class="sc-sf__similar-title">Similar products available in this size:</p><div class="sc-sf__similar" data-sf-similar><span class="sc-sf__loading">Loading…</span></div>`}
        <button type="button" class="sc-sf__link" data-sf-restart>Start over</button>
        <p class="sc-sf__summary">${sum}</p>`;
    }

    summary() {
      const p = this.state.profile;
      const tin = p.heightCm / 2.54;
      const ft = Math.floor(tin / 12), inch = Math.round(tin - ft * 12);
      const parts = [`${ft}'${inch}"`, `${Math.round(p.weightKg * 2.20462)} lbs`];
      if (p.age) parts.push(`${Math.round(p.age)} yrs`);
      return `Based on: ${parts.join(' · ')} · ${p.gender === 'women' ? 'Women' : 'Men'}`;
    }

    /* ---------- out of stock alternatives ---------- */
    async loadSimilar() {
      const box = this.body.querySelector('[data-sf-similar]');
      if (!box || !this.current) return;
      const want = SF.norm(this.current.label);
      const pr = this.product;
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const urls = [
        `${root}recommendations/products.json?product_id=${pr.id}&limit=10&intent=related`,
      ];
      if (pr.data && pr.data.category) urls.push(`${root}collections/${encodeURIComponent(pr.data.category)}/products.json?limit=40`);
      urls.push(`${root}collections/all/products.json?limit=60`);
      const seen = new Set([String(pr.id)]);
      const out = [];
      for (const url of urls) {
        if (out.length >= 8) break;
        try {
          const res = await fetch(url, { headers: { Accept: 'application/json' } });
          if (!res.ok) continue;
          const json = await res.json();
          for (const p of json.products || []) {
            if (out.length >= 8 || seen.has(String(p.id))) continue;
            const opts = (p.options || []).map((o) => (typeof o === 'string' ? o : o.name));
            let oi = opts.findIndex((n) => /size/i.test(n || ''));
            if (oi < 0) oi = 0;
            const key = `option${oi + 1}`;
            const v = (p.variants || []).find((x) => x.available && SF.norm(x[key] || (x.options || [])[oi]) === want);
            if (!v) continue;
            seen.add(String(p.id));
            const img = p.featured_image || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
            const priceCents = typeof v.price === 'number' ? v.price : Math.round(parseFloat(v.price) * 100);
            out.push({ title: p.title, url: p.url || `${root}products/${p.handle}`, img: typeof img === 'string' ? img : img.src, price: priceCents });
          }
        } catch (e) {}
      }
      if (!this.body.contains(box)) return;
      if (!out.length) {
        box.outerHTML = `<p class="sc-sf__msg">No similar items are in stock in this size right now.</p>`;
        return;
      }
      const fmt = (c) => {
        try { return new Intl.NumberFormat(pr.locale || undefined, { style: 'currency', currency: pr.currency || 'USD', minimumFractionDigits: c % 100 ? 2 : 0 }).format(c / 100); }
        catch (e) { return '$' + (c / 100).toFixed(2); }
      };
      const sized = (u) => (u ? u + (u.includes('?') ? '&' : '?') + 'width=400' : '');
      box.innerHTML = out.map((p) => `
        <a class="sc-sf__item" href="${esc(p.url)}">
          ${p.img ? `<img class="sc-sf__item-img" src="${esc(sized(p.img))}" alt="${esc(p.title)}" loading="lazy" width="400" height="533">` : '<span class="sc-sf__item-img"></span>'}
          <p class="sc-sf__item-title">${esc(p.title)}</p>
          <p class="sc-sf__item-price">${fmt(p.price)}</p>
        </a>`).join('');
    }

    /* ---------- events ---------- */
    onClick(e) {
      const t = e.target.closest('button, a');
      if (!t || !this.dialog.contains(t)) return;
      const s = this.state, p = s.profile;

      if (t.matches('[data-sf-close]')) return this.close();
      if (t.matches('[data-sf-back]')) {
        if (s.step === 'shape' && s.shapeIndex > 0) s.shapeIndex -= 1;
        else s.step = 'basics';
        return this.render();
      }
      if (t.dataset.unit) {
        this.readBasics();
        const [g, val] = t.dataset.unit.split(':');
        s.units[g] = val;
        return this.render();
      }
      if (t.dataset.gender) {
        this.readBasics();
        if (p.gender !== t.dataset.gender) {
          ['stomach', 'torso', 'thighs', 'hips', 'band', 'cup'].forEach((k) => delete p[k]);
        }
        p.gender = t.dataset.gender;
        return this.render();
      }
      if (t.dataset.sfNext === 'basics') {
        const errs = this.readBasics();
        const box = this.body.querySelector('[data-sf-error]');
        if (errs.length) { box.textContent = errs[0]; box.hidden = false; return; }
        s.step = 'shape'; s.shapeIndex = 0;
        return this.render();
      }
      if (t.dataset.shape) {
        const [k, v] = t.dataset.shape.split(':');
        p[k] = v;
        return this.render();
      }
      if (t.dataset.band) { p.band = Number(t.dataset.band); return this.render(); }
      if (t.dataset.cup) { p.cup = t.dataset.cup; return this.render(); }
      if (t.matches('[data-sf-skip-chest]')) { delete p.band; delete p.cup; return this.finish(); }
      if (t.dataset.sfNext === 'shape') return this.advance();
      if (t.dataset.tab) { s.tab = t.dataset.tab; return this.render(); }
      if (t.matches('[data-sf-restart]')) {
        sfClear();
        this.updateTrigger();
        s.profile = { gender: p.gender };
        s.step = 'basics'; s.tab = 'ideal';
        return this.render();
      }
      if (t.matches('[data-sf-add]')) return this.addToCart(t);
    }

    advance() {
      const s = this.state, steps = this.steps();
      const step = steps[s.shapeIndex];
      if (step && step.key !== 'chest' && !s.profile[step.key]) return;
      if (s.shapeIndex < steps.length - 1) { s.shapeIndex += 1; return this.render(); }
      this.finish();
    }

    finish() {
      sfSave(this.state.profile);
      this.updateTrigger();
      this.state.step = 'result';
      this.state.tab = 'ideal';
      this.render();
    }

    addToCart(btn) {
      const c = this.current;
      if (!c || !c.variant) return;
      const input = this.querySelector('[data-sf-variant]');
      const real = this.querySelector('.sc-sf__atc-real');
      if (!input || !real) return;
      input.value = c.variant.id;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      const done = () => {
        btn.disabled = false;
        btn.textContent = `Add size ${c.label} to cart`;
        this.close();
      };
      const onUpdate = () => { document.removeEventListener('shopify:cart:lines-update', onUpdate); setTimeout(done, 50); };
      document.addEventListener('shopify:cart:lines-update', onUpdate);
      setTimeout(() => { document.removeEventListener('shopify:cart:lines-update', onUpdate); if (btn.disabled) done(); }, 4000);
      real.disabled = false;
      real.click();
    }
  }

  if (!customElements.get('sc-size-finder')) customElements.define('sc-size-finder', ScSizeFinder);

  document.addEventListener('click', (e) => {
    const trig = e.target.closest('[data-sc-sf-open]');
    if (!trig) return;
    e.preventDefault();
    const root = document.getElementById(trig.dataset.scSfOpen + '-root');
    if (root && typeof root.open === 'function') root.open();
  });
})();
  } catch(e) { console.error(e); }
})();

})();
